export default {
  startSelling: 'Start Selling',
  growth: 'Fastest Growing E-commerce Platform',
  introduce: 'Introduction of Kilimall',
  process: 'Open store process',
  step1: 'Registration and certification',
  step2: 'Platform review',
  step3: 'Create a store',
  step4: 'Upload products',
  // 新版招商首页 旧版部分文案暂不删除 以防翻译资源已经被复用引发问题
  bannerTitle: 'Reach Your Customer On Kilimall',
  bannerSubtitle: 'Start selling your products online today',
  registerNow: 'Register Now',
  market: 'Africa is the continent with fasted growing e-commerce.',
  consumer: '1.3 billion potential e-commerce consumers',
  internet: '450 million',
  internetUser: 'Internet Users',
  dollars: '75 billion',
  dollarsShare: 'US Dollar Market Share',
  marketIntroduce: `Since 2013, the mobile Internet has developed rapidly in Africa, and Internet users have grown exponentially. 
  It is estimated that by 2025, Africa's e-commerce market will reach a total of 75 billion US dollars.`,
  platform: 'The Leading E-commerce Platform in East Africa',
  monthlySales:
    'Sellers who make monthly sales of $50,000 have grown year over year',
  rate: 'Repurchase rate',
  orderAmount: 'Average Order Amount',
  development: 'Kilimall has grown faster than many similar websites, and now Kilimall has become a trusted and favorite shopping site for African consumers.',
  advantage: 'Advantages of Kilimall',
  advantageTitle1: '10 Years Operating',
  advantageTitle2: 'Fulfilled by Kilimall Service',
  advantageTitle3: 'KiliShops All Over Africa',
  advantageContent1: `Since 2014, Kilimall started its journey of e-commerce in Africa. 
  We served millions of customers and delivered tens of millions of packages across the continent. 
  Kilimall is now a well-known brand in Africa.`,
  advantageContent2: `The most advanced logistics system in Africa, the fastest same-day delivery. 
  It allows you to stock up in advance to an African warehouse of 100,000 square meters.`,
  advantageContent3: `10,000+ KiliShop are all deployed in Africa, solving the last mile logistics. At the same time, 
  it also has the attributes of online and offline communities, which maximizes the order rate.`,
  join: 'Just Four Steps to Boost Your Business in Africa',
  registerTitle1: 'Registration',
  registerTitle2: 'Platform Review',
  registerTitle3: 'Create a Store',
  registerTitle4: 'Publish Your Product',
  registerText1: 'Register account and submit required forms',
  registerText2: 'Waiting for platform staff to review',
  registerText3: 'Set store name and login account',
  registerText4:
    'Successfully opened the store, enter the seller center to publish your first product',
  bottomTitle: 'Reach you customer on Kilimall',
  //   footer
  platformTitle: 'Kilimall - Africa\'s leading e-commerce platform',
  more: 'More Information of Kilimall',
  Kenya: 'Kenya site',
  sellerCenter: 'Seller Center',
  helpCenter: 'Help Center',
  joinUs: 'Register Now',
  trade: 'China-Africa Economic and Trade Expo',
  website: 'Official Website：www.kilimall.com.cn',
  phone: 'Contact Number：400-961-8893（Monday - Friday)',
  email: 'Seller Support Email：seller.support@kilimall.com',
  copyright: '©Copyright (c) 2022 Kilimall',
  copyrightCode: 'Hunan Internet Public Security Recordation ICP No. 19002592-1'
}
